import { ReactComponent as RightArrow } from 'assets/icons/chevron-right-icon.svg'
import { Field } from 'formik'
import { Link as RouterLink } from 'react-router-dom'
import styled from 'styled-components'
import { borderRadius, breakpoints, colors, fontFamily, fontWeight, typography } from 'theme'

export const MobilePlatformContainer = styled.div({
  fontFamily: fontFamily.inter,
  fontSize: typography.xxs.fontSize,
  fontWeight: fontWeight.semibold,
  lineHeight: typography.xxs.lineHeight,
  letterSpacing: '0em',
  textAlign: 'left',
  color: colors.primary.medium,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
})

export const MenuContainer = styled.div({
  border: '0px 0px 1px 0px',
  display: 'flex',
  justifyContent: 'space-between',
  // flexDirection: 'column',
  fontFamily: fontFamily.inter,
  fontSize: typography.xs.fontSize,
  fontWeight: fontWeight.semibold,
  lineHeight: typography.xxs.lineHeight,
  letterSpacing: '0em',
  textAlign: 'left',
  color: colors.primary.medium,
})

export const AvailabilityContainer = styled.div<{ isColumn?: boolean }>(
  {
    display: 'flex',
    width: '50px',
    height: '15px',
    top: '5px',
    left: '203px',
    gap: '5px',
  },
  ({ isColumn }) =>
    isColumn && {
      flexDirection: 'column',
    },
)

export const AvailabilityTimeStamp = styled.div({
  ...typography.xs,
})

export const MenuPublishTimeStamp = styled.div({
  color: colors.primary.medium,
  fontFamily: fontFamily.inter,
  fontSize: '9px',
  fontStyle: 'normal',
  fontWeight: fontWeight.normal,
  lineHeight: '150%' /* 13.5px */,
  whiteSpace: 'nowrap',
})

export const TextButton = styled.button({
  fontWeight: fontWeight.semibold,
  color: colors.primary.DEFAULT,
  ':disabled': {
    color: colors.gray.DEFAULT,
  },
})

export const Grid = styled.div({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '24px',
  height: 'auto',
  width: '100%',
})

export const LocationContainer = styled.div<{ width?: number | string }>({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  maxWidth: '1280px',
  width: '100%',
  paddingBottom: '5rem',
  backgroundColor: '#FAFAFA',
  gap: '24px',
})

export const LocationName = styled.div<{
  width?: number | string | null
  singleLocation: number | undefined
}>(
  {
    fontSize: '20px',
    lineHeight: '28px',
    fontWeight: fontWeight.semibold,
    width: 'auto',
    padding: '12px 0',
    border: '1px solid #D7D7D7',
    borderRadius: '8px',
  },
  ({ width }) => width && { width },
  ({ singleLocation }) =>
    singleLocation && {
      border: 0,
    },
)

export const LocationHeader = styled.div({
  display: 'flex',
  justifyContent: 'stretch',
  alignItems: 'center',
  width: '100%',
  flexWrap: 'wrap-reverse',
})

export const LocationFormItem = styled.div<{ width?: string | null; upchargeReadOnly?: boolean }>(
  {
    display: 'flex',
    height: '217px',
    width: '100%',
    padding: '24px 24px',
    backgroundColor: colors.gray[450],
    borderRadius: '8px',
    flex: '1',
  },
  ({ upchargeReadOnly }) =>
    upchargeReadOnly && {
      width: '1280px',
    },
  ({ width }) => width && { width },
  {
    [`@media ${breakpoints.xxs}`]: {
      minWidth: '290px',
    },
    [`@media ${breakpoints.xs}`]: {
      minWidth: '344px',
    },
    [`@media ${breakpoints.sm}`]: {
      minWidth: '344px',
    },
    [`@media ${breakpoints.md}`]: {
      minWidth: '436px',
    },
    [`@media ${breakpoints.xl}`]: {
      minWidth: '436px',
    },
    [`@media ${breakpoints.xxl}`]: {
      minWidth: '516px',
    },
  },
)

export const LocationConnectionContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  height: 'auto',
  width: '100%',
  maxWidth: '100%',
})

type StatusProps = { isSuccess: boolean }

export const StatusContainer = styled.div<{ width?: string }>(
  {
    display: 'flex',
    gap: '5px',
    alignItems: 'center',
    width: 'auto',
  },
  ({ width }) => width && { width },
)

export const StatusText = styled.h4<StatusProps>(
  {
    display: 'block',
    fontSize: '10px',
    fontWeight: fontWeight.medium,
    color: colors.red.darkRed,
    fontStyle: 'italic',
    '&:first-letter': {
      textTransform: 'capitalize',
    },
  },
  ({ isSuccess }) =>
    isSuccess && {
      color: colors.green.darkGreen,
    },
)

export const PosSystemContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  marginLeft: '10px',
})

export const PosSystemLabel = styled.span({
  fontFamily: fontFamily.inter,
  fontSize: '10px',
  fontWeight: fontWeight.bold,
  color: '#292929',
  fontStyle: 'italic',
  lineHeight: '150%',
  textAlign: 'right',
})

export const PosSystemValue = styled.span({
  fontFamily: fontFamily.inter,
  fontSize: '10px',
  fontWeight: fontWeight.medium,
  color: '#292929',
  fontStyle: 'italic',
  lineHeight: '150%',
})

type EnqueuedProps = { isVisible: boolean }

export const SmallText = styled.span<EnqueuedProps>(
  {
    display: 'none',
    fontSize: '0.7rem',
    color: 'black',
    textTransform: 'none',
    marginLeft: '5px',
  },
  ({ isVisible }) =>
    isVisible && {
      display: 'inline',
    },
)

export const TimeStampText = styled.p({
  width: '100%',
  display: 'block',
  fontSize: '1rem',
  fontWeight: fontWeight.medium,
  color: colors.blue[700],
  margin: '.5rem 0',
})

export const EditMenuLabel = styled.div({
  fontSize: '.8rem',
  fontWeight: fontWeight.bold,
  color: colors.black,
  margin: '.5rem 0 0 0',
})

export const ButtonContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  columnGap: '0.5rem',
  width: '100%',
  marginBottom: 0,
})

export const InputUpchargeContainer = styled.div({
  display: 'inline-block',
  position: 'relative',
  width: 128,
  '&::before': {
    position: 'absolute',
    top: 8,
    right: '.5em',
    content: '"%"',
  },
})

export const Input = styled(Field)({
  width: '100%',
  padding: '0.5rem 1.5rem .5rem 1rem',
  backgroundColor: colors.white,
  appearance: 'none',
  borderWidth: 1,
  borderColor: colors.blue['300'],
  borderRadius: borderRadius.lg,
  fontSize: '1rem',
  lineHeight: '1.5rem',
  fontWeight: fontWeight.bold,
})

export const SectionHeaderRight = styled.div({
  display: 'flex',
  columnGap: '0.75rem',
})

export const Link = styled(RouterLink)({
  whiteSpace: 'nowrap',
})

export const ChevronRightIcon = styled(RightArrow)({
  margin: '.2rem 0',
})

export const MenuErrorMessage = styled.div({
  margin: '.5rem 0',
})

export const IconContainer = styled.button(
  {
    margin: '.3rem',
    img: {
      height: 25,
      width: 25,
    },
  },
  {
    ':disabled': {
      backgroundColor: colors.gray[300],
      borderColor: colors.gray[300],
      color: colors.gray.dark,
      img: {
        color: colors.gray.dark,
      },
    },
  },
)

export const Icon = styled.img<{ iconSize?: string; hoverEffect?: boolean; disabled?: boolean }>(
  {
    width: '6px',
    height: '6px',
  },
  ({ iconSize }) =>
    iconSize && {
      width: `${iconSize}px`,
      height: `${iconSize}px`,
    },
  ({ hoverEffect }) =>
    hoverEffect && {
      '&:hover': {
        cursor: 'pointer',
        '&:not(:active)': {
          backgroundColor: 'rgb(219, 234, 254)',
        },
      },
    },
  ({ disabled }) =>
    disabled && {
      cursor: 'not-allowed',
      opacity: 0.5,
      pointerEvents: 'none',
    },
)

export const TextContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
})

export const LocationHoursContainer = styled.div({
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-start',
})

export const ConnectionLink = styled.a({
  fontFamily: fontFamily.inter,
  fontSize: typography.xs.fontSize,
  fontWeight: fontWeight.semibold,
  lineHeight: typography.xxs.lineHeight,
  color: colors.blue[700],
  ':hover': {
    cursor: 'pointer',
    textDecoration: 'underline',
  },
})

export const RenameInputLabel = styled.div({
  fontFamily: fontFamily.inter,
  fontSize: typography.xxs.fontSize,
  fontStyle: 'normal',
  fontWeight: fontWeight.normal,
  lineHeight: '150%',
  marginBottom: '16px',
  color: colors.gray[500],
})

export const PopoverMenu = styled.div({
  background: '#fff',
  borderRadius: '8px',
  boxShadow: '0px 4px 60px 0px rgba(0, 0, 0, 0.20)',
  minWidth: '120px',
  padding: '4px 0',
  display: 'flex',
  flexDirection: 'column',
})

export const PopoverMenuItem = styled.div<{
  danger?: boolean
}>(({ danger }) => ({
  padding: '8px 16px',
  marginLeft: '5px',
  marginRight: '5px',
  cursor: 'pointer',
  fontFamily: 'Inter, sans-serif',
  fontSize: '14px',
  color: danger ? '#E53935' : '#222',
  background: 'none',
  border: 'none',
  borderRadius: '4px',
  textAlign: 'left',
  transition: 'background 0.2s',
  '&:hover': {
    background: '#F5F5F5',
  },
}))
